import Raven from 'raven-js';
import { useEffect, useState } from 'react';
import { Redirect } from 'react-router-dom';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import { getQueryParams } from 'pricing-pages-lib/utils/queryParamUtils';
import { getIsFreePortalAndOwnedProducts } from 'ui-addon-upgrades/_core/common/eligibility/getIsFreePortal';
import { getProductLineFromApiNameString } from 'ui-addon-upgrades/_core/features/FeaturesUtils';
import { useSelector } from 'react-redux';
import ApiNameToUpgradeProductMap from 'self-service-api/constants/ApiNameToUpgradeProductMap';
import { upgradeProductToTrialIds } from 'self-service-api/constants/Trials';
import ErrorPage from '../../../components/error-page/ErrorPage';
import { TRIAL_UPGRADE_PAGE_CONTAINER } from '../../../constants/ErrorBoundaryNames';
import { PRICING_AND_PURCHASING_FAILED_STATUS } from '../../../constants/ErrorCauses';
import { useIsHC0119Variant } from '../../../hooks/hc0119Hooks';
import { useAppSelector } from '../../../reducers';
import { getIsCurrentTrialSelector } from '../../../selectors/ActiveTrialsSelectors';
import { hasPricingAndPurchasingFailedSelector, hasPricingAndPurchasingSucceededSelector } from '../../../selectors/LoadingStateSelectors';
import { getIsAcceptanceTest } from '../../../utils/testUtils';
import { withErrorBoundary } from '../../ErrorBoundary';
import TrialUpgradePage from './TrialUpgradePage';
import { jsx as _jsx } from "react/jsx-runtime";
const TrialUpgradePageContainer = () => {
  const queryParams = getQueryParams();
  const apiName = queryParams.apiName;
  const isAcceptanceTest = getIsAcceptanceTest();
  const {
    isHC0119Variant,
    isHC0119Fetched
  } = useIsHC0119Variant(apiName);
  const productLine = getProductLineFromApiNameString(apiName).toLowerCase();
  const hasPricingAndPurchasingSucceeded = useAppSelector(hasPricingAndPurchasingSucceededSelector);
  const upgradeProduct = ApiNameToUpgradeProductMap[apiName];
  let trialId;
  if (upgradeProduct !== undefined) {
    // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    trialId = upgradeProductToTrialIds[upgradeProduct];
  }
  const isCurrentTrial = useSelector(state => {
    return getIsCurrentTrialSelector(state, trialId);
  });
  const hasPricingAndPurchasingFailed = useAppSelector(hasPricingAndPurchasingFailedSelector);
  const [data, setData] = useState();
  useEffect(() => {
    getIsFreePortalAndOwnedProducts().then(isFreePortalAndOwnedProducts => {
      setData({
        upgradePointApiName: apiName,
        isFreePortal: isFreePortalAndOwnedProducts.isFreePortal
      });
    }).catch(error => {
      Raven.captureException(error, {
        extra: {
          message: 'Unexpected error setting up the TrialPPPContainer',
          apiName
        }
      });
      console.error('Error fetching data for TrialPPPContainer', error);
      return /*#__PURE__*/_jsx(Redirect, {
        to: `/${productLine}`
      });
    });
  }, [apiName, productLine]);
  if (!data || !isHC0119Fetched || !hasPricingAndPurchasingSucceeded) {
    return /*#__PURE__*/_jsx(UILoadingSpinner, {
      minHeight: 200,
      size: "md",
      grow: true
    });
  }
  if (hasPricingAndPurchasingFailed) {
    return /*#__PURE__*/_jsx(ErrorPage, {
      errorCause: PRICING_AND_PURCHASING_FAILED_STATUS
    });
  }
  if (!isHC0119Variant && !isAcceptanceTest || !isCurrentTrial && !isAcceptanceTest) {
    return /*#__PURE__*/_jsx(Redirect, {
      to: `/${productLine}`
    });
  }
  return /*#__PURE__*/_jsx(TrialUpgradePage, {
    apiName: data.upgradePointApiName
  });
};
export default withErrorBoundary(TrialUpgradePageContainer, {
  boundaryName: TRIAL_UPGRADE_PAGE_CONTAINER,
  redirectCallback: () => '/'
});